'use client';
import '@radix-ui/themes/styles.css';
import { Layout } from '@/shared/ui/layouts';
import { FullscreenProvider } from '@/flat-pages/game/FullscreenContext';
import { NavigationGuardProvider } from '@/flat-pages/game/NavigationGuardProvider';
import useIsMobile from '@/shared/hooks/useIsMobile';
import { GameDesktop } from '@/flat-pages/game/GameDesktop';
import { Game } from '@/flat-pages/game';

function GamePage() {
  const isMobile = useIsMobile();

  return (
    <FullscreenProvider>
      <NavigationGuardProvider>
        <Layout flexMain={true}>
          {isMobile && <Game fullScreenModeOn={false} isDemo={true} />}
          {!isMobile && <GameDesktop fullScreenModeOn={false} isDemo={true} />}
        </Layout>
      </NavigationGuardProvider>
    </FullscreenProvider>
  );
}

export default GamePage;
